import React from 'react';
import styled from 'styled-components';

import { FlexBox, FlexBoxSpaceBetween } from '@ecp/common/src/layouts/flex/styled';
import { ReactComponent as NoticeSrc } from '@ecp/common/src/assets/image/image_notice_footer.svg';

const FooterNotice = () => {
  return (
    <FlexBoxSpaceBetween width={'1920px'} height={'200px'}>
      <FlexBox>
        <Container>
          <NoticeSrc />
        </Container>
      </FlexBox>
    </FlexBoxSpaceBetween>
  );
};

export default FooterNotice;

const Container = styled(FlexBox)`
  display: flex;
`;
